import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import loginView from '@/components/Login_View'
import forgotPasswordRequestView from '@/components/View_Forgot_Password_Request'
import forgotPasswordPostView from '@/components/View_Forgot_Password_Post'

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: loginView
    },
    {
      path: '/forgot-password-request',
      name: 'forgot-password-request',
      component: forgotPasswordRequestView
    },
    {
      path: '/forgot-password-post',
      name: 'forgot-password-post',
      component: forgotPasswordPostView
    },
    {
      path: '/*',
      name: '404',
      component: loginView
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/not_logged.js